import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { ExclusionVehiculos } from "./solicitud-vehiculos.component";
import { ExclusionVehiculosService } from "./solicitud-vehiculos.service";
import {FileUploadModule} from "ng2-file-upload/ng2-file-upload";
import { CalendarModule } from 'primeng/primeng';
import { DataFilterPipeVehiculosPlaca } from "./solicitud-vehiculos.filter";

@NgModule({
    declarations: [ExclusionVehiculos,DataFilterPipeVehiculosPlaca],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        CalendarModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        Ng2Webstorage],
    providers: [ExclusionVehiculosService],
    exports: [ExclusionVehiculos]

})

export class SolicitudVehiculosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-vehiculos.module.ts